const TITLE = process.env.VUE_APP_PROJECT_NAME;
export default {
  methods: {
    pageTitle(title = "") {
      if (title) {
        document.title = `${title} | ` + TITLE;
      } else {
        document.title = TITLE;
      }
    }
  }
};
